<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h1 class="u">Шаблоны квитанций <router-link class="btn btn-primary" :to="{ name: 'bill-template-add' }">+ Добавить шаблон квитанции</router-link></h1>

    <div class="sub-nav">
      <router-link class="btn btn-default btn-sm" :to="{ name: 'settings' }">← Назад к Настройкам</router-link>
    </div>

    <resource-list
      url="/bill-templates"
      current-sort="file"
      :show-per-page="false"
      resource-name="bill_templates"
      :action-routes="actionRoutes"
      :fields="fields"
      :filters="filters"
    />

  </div>
</template>

<script>
import resourceList from '@/components/ResourceList'

export default {
  name: 'bill-templates',
  components: { resourceList },
  data () {
    return {
      fields: [
        { name: 'file', label: 'Название', sort: true }
      ],
      filters: {
        name: ''
      },
      actionRoutes: [
        { name: 'bill-template-details', label: 'Открыть детали' }
      ]
    }
  }
}
</script>


// WEBPACK FOOTER //
// BillTemplates.vue?00d49384